<template>
    <div>
        <div class="btn-wrapper" v-show="playlist">
            <div @click="onAutoClicked()" class="playlist-btn" :class="playlist.auto ? 'on' : 'off'">
                <p>auto</p>
                <p>is {{ playlist.auto ? 'on' : 'off'  }}</p>
            </div>

            <div @click="onPauseClicked()" class="playlist-btn play-btn" :class="playlist.paused ? 'off' : 'on'">
                <div v-show="playlist.paused">
                    <span><i class="fas fa-play"></i></span>
                </div>
                <div v-show="!playlist.paused">
                    <span><i class="fas fa-pause"></i></span>
                </div>
            </div>

            <div @click="onRepeatClicked()" class="playlist-btn" :class="[playlist.repeat ? 'on' : 'off', playlist.auto && 'disabled']">
                <p>repeat</p>
                <p>is {{ playlist.repeat ? 'on' : 'off'  }}</p>
            </div>
        </div>

        <!-- Auto mode confirmation -->
        <modal :title="'Are sure?'" ref="autoModal" v-on:toggled="modalToggled">
            <slot slot-scope="modal">
                <div class="padded top-margin-sm">
                    <p>All coffees added in this brew queue will be removed by automating the brew queue.</p>
                </div>
                <div class="btn-pair-wrapper top-margin-md">
                    <button @click="modal.close" class="workplace-btn">cancel</button>
                    <button @click="onAutoConfirmed()" class="red-btn">proceed</button>
                </div>
            </slot>
        </modal>

        <!-- Pause duration -->
        <modal :title="'Pause playlist for...'" ref="pauseModal" v-on:toggled="modalToggled">
            <slot slot-scope="modal">
                <div class="top-margin-sm">
                    <div v-for="duration in PAUSE_DURATIONS" class="pause-duration">
                        <div @click="onPauseConfirmed(duration)">{{ duration }}</div>
                    </div>
                    <button @click="modal.close" class="workplace-btn">cancel</button>
                </div>
            </slot>
        </modal>
    </div>
</template>

<script>
    import Modal from './modal-workplace'
    import DateMixin from '../../mixins/date-mixin'


    export default {
        components: {
            Modal
        },
        props: {
            playlist: Object,
        },
        methods: {
            onAutoClicked() {
                // When turning on auto mode, confirm with user if playlist is not empty
                if (!this.playlist.auto && this.$parent.$refs.playlist.products.length > 0) {
                    this.$refs.autoModal.show();
                } else {
                    this.$emit('auto');
                }
            },
            onAutoConfirmed() {
                this.$emit('auto');
                this.$refs.autoModal.close();
            },
            onPauseClicked() {
                if (!this.playlist.paused) {
                    this.$refs.pauseModal.show();
                } else {
                    this.$emit('pause')
                }
            },
            onRepeatClicked() {
                if (!this.playlist.auto) {
                    this.$emit('repeat')
                }
            },
            onPauseConfirmed(duration) {
                const resumeAt = this.getResumeTime(duration);
                this.$emit('pause', resumeAt);

                // Wait a little bit so that user can see the button selected
                setTimeout(() => this.$refs.pauseModal.close(), 750)
            },
            getResumeTime(duration) {
                switch (duration) {
                    case '1 week':
                        return this.getNextWeek().toISOString();
                    case '1 month':
                        return this.getNextMonth().toISOString();
                    case 'indefinitely':
                        return;
                }
            },
            modalToggled(shown) {
                this.$emit('modal-toggled', shown);
            }
        },
        created() {
            // Define constants
            this.PAUSE_DURATIONS = ['1 week', '1 month', 'indefinitely'];
        },
        mixins: [DateMixin]
    }
</script>

<style scoped lang="scss">
    .btn-wrapper {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 1rem 1rem;
    }

    .playlist-btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #F4F7F1;
        font-weight: bold;
        width: 64px;
        height: 64px;
        box-sizing: border-box;
        border-radius: 50%;
        background-color: #E15F60;
        cursor: pointer;
    }

    .playlist-btn>p {
        margin: 0;
        color: white;
        font-family: Futura, "Trebuchet MS", Arial;
    }

    .play-btn {
        width: 74px;
        height: 74px;
        font-size: 22px;
    }

    .on {
        background-color: #43B51B;
        border: solid 2px #43B51B;
    }

    .off {
        background-color: #E15F60;
        border: solid 2px #E15F60;
    }

    .pause-duration {
        width: 100%;
        text-align: center;
        margin-bottom: 1rem;
        border: 1px solid #E15F60;
        border-radius: 4px;
        transition:0s 1s;
        cursor: pointer;
    }

    .pause-duration div {
        padding: 1rem 0;
    }

    .pause-duration:active {
        background-color: #E15F60;
        color: #F4F7F1;
        transition:0s;
    }

    .disabled {
        opacity: 0.5;
    }
</style>
